// extracted by mini-css-extract-plugin
export default {"overlay":"modal_overlay__D1Rh8","modal_window":"modal_modal_window__m1UqG","modal_content":"modal_modal_content__TKjUx","modal_close":"modal_modal_close__KWjJB"};